import { ColorOptions } from '@jfs/ui-new'
import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'
import { getRandomAlphaNumString } from '../../network/config'
import { Client } from './Client'

export const MerchantTheme = types.model('merchanttheme', {
  isMerchantThemeEnabled: types.optional(types.boolean, false),
  colorTheme: types.optional(types.string, ''), //'#2469FF
  headingText: types.optional(types.string, ''), //#FFFFFF
  brandColor: types.optional(types.string, ''), //#2469FF
  bodyTextColor: types.optional(types.string, ''), //#000000
  bodyBgColor: types.optional(types.string, ''), //#FFFFFF
})

const Config = types
  .model('Config', {
    isInitialLoadComplete: types.optional(types.boolean, false),
    version: types.optional(types.string, ''),
    client: types.optional(Client, {}),
    channel: types.optional(types.string, 'WEB'),
    paymentType: types.optional(types.string, 'PG'),
    env: types.optional(types.string, ''),
    isTransactionAllowed: types.optional(types.boolean, true),
    isTwofaRequired: types.optional(types.boolean, true),
    isTwofaValidated: types.optional(types.boolean, false),
    enableCommonSavedCards: types.optional(types.string, ''),
    securityId: types.optional(types.string, ''),
    globalNote: types.optional(types.string, ''),
    showPopup: types.optional(types.boolean, true),
    showBackPopup: types.optional(types.boolean, true),
    showHeaderCloseIcon: types.optional(types.boolean, true),
    failedCount: types.optional(types.number, 0),
    isMoalDisplaying: types.optional(types.boolean, false),
    closeModal: types.optional(types.boolean, false),
    merchantTheme: types.optional(MerchantTheme, {}),
    rightHeaderClicked: types.optional(types.boolean, false),
    savedCardApiStatus: types.optional(types.string, 'initial'),
    isSubscriptionEnabled: types.optional(types.boolean, true),
    isIntegration: types.optional(types.string, 'false'),
    uniqueWindowId: types.optional(types.string, ''),
    hideHeaderCloseIcon: types.optional(types.boolean, false),
    emiEligibiltyStep: types.optional(types.number, 0),
    addNewCardModeVisible: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    updateHeaderClose(isShow: boolean) {
      self.showHeaderCloseIcon = isShow
    },
    updateEmiEligibilityStep(step: number) {
      self.emiEligibiltyStep = step
    },
    updateMerchantTheme() {
      if (!self.merchantTheme.brandColor) {
        self.merchantTheme.brandColor = '#2469FF' as ColorOptions
      }
      if (!self.merchantTheme.headingText) {
        self.merchantTheme.headingText = '#FFFFFF' as ColorOptions
      }
      if (!self.merchantTheme.bodyBgColor) {
        self.merchantTheme.bodyBgColor = '#FFFFFF' as ColorOptions
      }
      if (!self.merchantTheme.bodyTextColor) {
        self.merchantTheme.bodyTextColor = '#000000' as ColorOptions
      }
    },
    updateRightHeaderClick(show: boolean) {
      self.rightHeaderClicked = show
    },
    updateModalDisplaying(isDisplaying: boolean) {
      self.isMoalDisplaying = isDisplaying
    },
    updateCancelModal(isCancel: boolean) {
      self.closeModal = isCancel
    },
    updateFailedCount(failedCount: string) {
      self.failedCount = Number(failedCount)
    },
    updateShowBackPopup(show: boolean) {
      self.showBackPopup = show
    },
    updateShowPopup(show: boolean) {
      self.showPopup = show
    },
    completeInitialLoading() {
      self.isInitialLoadComplete = true
    },
    updateConfigData(parms: any) {
      if (parms?.clientId) {
        self.client.clientId = Number(parms?.clientId)
      }
      self.version = parms?.version
      self.channel = parms?.channel
      self.paymentType = parms?.paymentType
      self.env = parms?.env
      self.securityId = parms?.securityId
      self.globalNote = parms?.globalNote
    },
    setHideHeaderCloseIcon(val: boolean) {
      self.hideHeaderCloseIcon = val
    },
    updateAddNewCardModeVisible(val: boolean) {
      self.addNewCardModeVisible = val
    },
  }))

const ConfigInitialData = Config.create({
  uniqueWindowId: getRandomAlphaNumString(16),
})

export type ConfigType = Instance<typeof Config>
export { Config, ConfigInitialData }
